<!--  -->
<template>
  <div>

    <div class="strate_box">
      <div>
        消息类型：
      </div>
      <div>
        <el-radio-group v-model="obr.messytie" @change="messagechangemessytie">
          <el-radio v-for="items,indexs in meassagearrgo" :key="indexs" :label="items.key">{{ items.value }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-show="obr.messytie === 1">
      <div class="strate_box">
        <div>
          选择的消息：
        </div>
        <div>
          {{ messagename }}
        </div>
      </div>
      <el-input v-model="objr.title" clearable style="width:200px;" placeholder="请输入标题" />
      <el-input v-model="objr.customerMessageNo" clearable style="width:200px;margin:0 20px" placeholder="请输入编号" />
      <el-select v-model="objr.msgType" placeholder="请选择">
        <el-option
          v-for="itemr in selectoptionse"
          :key="itemr.key"
          :label="itemr.value"
          :value="itemr.key"
        />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="searchclickr">搜索</el-button>
      <el-button type="primary" @click="rechargeclickr">重置</el-button>
      <el-table
        ref="table"
        :key="refreshKey"
        :data="publicAdvertListr"
        style="width: 100%"
      >
        <el-table-column

          label="选项"
          width="100"
        >
          <template slot-scope="scope">
            <input
              v-model="scope.row.checkboxFlag"
              type="checkbox"
              @click="handleChangeSelectone(scope.$index, scope.row)"
            >
            {{ scope.row.$index }}
          </template>
        </el-table-column>
        <el-table-column
          prop="customerMessageNo"
          label="编号"
        />
        <el-table-column
          prop="title"
          label="标题"
        />
        <el-table-column
          prop="msgTypeStr"
          label="类型"
        />
        <el-table-column

          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="primary" @click="timingpreview(scope.row,1)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        ref="paginationbox"
        :total="newtotalr"
        @size-change="fetchPageSizer($event)"
        @current-change="fetchCurrentPager"
      />
    </div>
    <div v-show="obr.messytie === 2">
      <div class="strate_box">
        <div>
          选择的消息：
        </div>
        <div>
          {{ templatename }}
        </div>
      </div>
      <el-table
        :key="refreshKeyr"
        :data="templatedata"
        style="width: 100%"
      >
        <el-table-column

          label="选项"
          width="100"
        >
          <template slot-scope="scope">
            <input
              v-model="scope.row.checkboxFlag"
              type="checkbox"
              @click="handleChangeSelectonewe(scope.$index, scope.row)"
            >
            {{ scope.row.$index }}
          </template>
        </el-table-column>
        <el-table-column
          prop="templateMessageAdminNo"
          label="编号"
        />
        <el-table-column
          prop="title"
          label="标题"
        />
        <el-table-column

          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="primary" @click="timingpreview(scope.row,2)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="templatetotalre"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <PreviewDialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import { customercreatlist, templatelist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import PreviewDialog from '../../timedPush/components/PreviewDialog'
export default {
  components: {
    PaginationRight,
    PreviewDialog
  },
  props: {
    selectoptionse: {
      type: Array,
      default: () => ([])
    },
    oneselectarr: {
      type: Object,
      default: () => ({})
    },
    twoselectarr: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      priwdialogVisible: false,
      obr: {

        messytie: 1
      },
      kefuid: null,
      mobanid: null,
      temrascalkeywords: null,

      messagename: null,
      // 消息类型数组
      meassagearrgo: [
        {
          key: 1,
          value: '客服消息'
        },
        {
          key: 2,
          value: '模板消息'
        }
      ],
      publicAdvertListr: [],
      refreshKey: 0,
      newtotalr: null,
      objr: {
        title: null,
        customerMessageNo: null,
        msgType: null,
        page: 1,
        pageSize: 10
      },

      templatename: null,
      refreshKeyr: 0,
      templatedata: [],
      templatetotalre: null,
      objrr: {
        page: 1,
        pageSize: 10
      }
    }
  },
  watch: {
    oneselectarr: function() {
      console.log('oneselectarr', this.oneselectarr)
      this.mentwoarr(this.oneselectarr)
    },

    twoselectarr: function() {
      console.log('twoselectarr', this.twoselectarr)
      this.temparr(this.twoselectarr)
    },
    deep: true

  },
  created() {
    // this.menuList()
    // this.gettemplatelist()
  },
  mounted() {

  },
  methods: {
    // 获取客服消息
    menuList() {
      customercreatlist(this.objr).then(res => {
        this.publicAdvertListr = res.data.list
        this.publicAdvertListr.forEach(item => {
          item.checkboxFlag = false
          if (item.customerMessageNo === this.kefuid) {
            item.checkboxFlag = true
          }
        })
        this.newtotalr = res.data.total
      })
    },
    mentwoarr(res) {
      this.publicAdvertListr = res.list
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
        if (item.customerMessageNo === this.kefuid) {
          item.checkboxFlag = true
        }
      })
      this.newtotalr = res.total
    },
    temparr(res) {
      this.templatedata = res.list
      this.templatedata.forEach(item => {
        item.checkboxFlag = false
        if (item.templateMessageAdminNo === this.mobanid) {
          item.checkboxFlag = true
        }
      })
      this.templatetotalre = res.total
    },
    // 获取模板消息 接口
    async gettemplatelist() {
      const data = await templatelist(this.objrr)
      this.templatedata = data.data.list
      this.templatedata.forEach(item => {
        item.checkboxFlag = false
        if (item.templateMessageAdminNo === this.mobanid) {
          item.checkboxFlag = true
        }
      })
      this.templatetotalre = data.data.total

      console.log('模板列表', data)
    },
    messagechangemessytie(val) {
      if (val === 1) {
        console.log('我是客服', val)
        this.$emit('gion', this.obr, this.kefuid)
      }
      if (val === 2) {
        console.log('我是模板', val)
        this.$emit('gion', this.obr, this.mobanid)
      }
    },
    searchclickr() {
      this.menuList()
    },
    rechargeclickr() {
      this.objr = {
        title: null,
        customerMessageNo: null,
        msgType: null,
        page: 1,
        pageSize: 10
      }
      this.menuList()
    },
    handleChangeSelectone(index) {
      console.log(this.publicAdvertListr[index])
      if (!this.publicAdvertListr[index].checkboxFlag) {
        this.messagename = this.publicAdvertListr[index].title
        this.kefuid = this.publicAdvertListr[index].customerMessageNo
        this.$emit('gion', this.obr, this.kefuid)
      } else {
        // this.selectData = null
      }
      this.publicAdvertListr.forEach(item => {
        item.checkboxFlag = false
      })
      this.publicAdvertListr[index].checkboxFlag = true
      this.refreshKey = Math.random()
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },

    fetchPageSizeone(e) {
      this.objrr.pageSize = e
      this.gettemplatelist()
    },
    fetchCurrentPageone(e) {
      this.objrr.page = e
      this.gettemplatelist()
    },
    // checkbox模板单选
    handleChangeSelectonewe(index) {
      if (!this.templatedata[index].checkboxFlag) {
        this.templatename = this.templatedata[index].title
        this.mobanid = this.templatedata[index].templateMessageAdminNo
        this.$emit('gion', this.obr, this.mobanid)
      } else {
        // this.selectData = null
      }
      this.templatedata.forEach(item => {
        item.checkboxFlag = false
      })
      this.templatedata[index].checkboxFlag = true
      this.refreshKeyr = Math.random()
    },
    // gion(val) {
    //   this.$emit('gion', val)
    //   console.log(val)
    // }
    send() {
      this.publicAdvertListr.forEach((items) => {
        items.checkboxFlag = false
        this.refreshKey = Math.random()
        this.$nextTick(function() {
          if (items.customerMessageNo === this.kefuid) {
            items.checkboxFlag = true
            this.refreshKey = Math.random()
          }
        })
      })
      this.templatedata.forEach((items) => {
        items.checkboxFlag = false
        this.refreshKeyr = Math.random()
        this.$nextTick(function() {
          if (items.templateMessageAdminNo === this.mobanid) {
            items.checkboxFlag = true
            this.refreshKeyr = Math.random()
          }
        })
      })
      console.log('666', this.kefuid, this.publicAdvertListr)
    },
    // 客服预览
    timingpreview(val, id) {
      console.log('val', val)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(val, id)
      }, 100)
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
.strate_box{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  div{
    flex-shrink: 0;
  }
   span{
      margin-left: 10px;
   }
}
.copy_box{
  margin-left: 10px;
}
</style>
